import { css } from 'styled-components';
import { vars } from '$util/theme';

/*
* NOTE: implementation leveraging styled-components features but resulting in sub-par css generation
*       left in as comment for devs to study

export const scFocusRing = (type?: string, designType?: string) => css`
  &:focus {
    outline: none;
    ${type === 'button'
      ? `border-color: ${
          designType === 'primary' ? '#fff' : vars.quantumverse.color.brandBase100
        }; box-shadow: ${vars.quantumverse.shadow.focus};`
      : `box-shadow: inset 0 0 0 1px ${vars.quantumverse.color.brandBase100}, ${vars.quantumverse.shadow.focus};`}
  }
`;
*/

export const focusRing = css`
  &:focus {
    outline: none;
    &.primary:not(:active) {
      border-color: #fff;
      box-shadow: ${vars.quantumverse.shadow.focus};
    }
    &.secondary:not(:active) {
      border-color: ${vars.quantumverse.reskinColors.purple500};
      box-shadow: ${vars.quantumverse.shadow.focus};
    }
    &:not(button) {
      box-shadow:
        inset 0 0 0 2px ${vars.quantumverse.reskinColors.purple500},
        ${vars.quantumverse.shadow.focus};
      @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
        box-shadow:
          inset 0 0 0 1.5px ${vars.quantumverse.reskinColors.purple500},
          ${vars.quantumverse.shadow.focus};
      }
    }
  }
`;
